export default "__VITE_ASSET__BITMRl9i__"